import { createContext } from 'react';
import type { ArTableViewSort } from '#types/System.Artifacts.types';

export type ArTableViewSortContextValue = {
  viewSort: ArTableViewSort;
  setViewSort: (next: ArTableViewSort) => void;
};

export const ArTableViewSortContext =
  createContext<ArTableViewSortContextValue | null>(null);

